<template></template>

<script setup>
console.log('**** Intentionally ignoring this element.')
</script>
